import { AfterContentChecked, Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TableColumnType } from 'src/app/constants/table';

import { ResourceLink } from 'src/app/models/resource-link';
import { TableColumn } from 'src/app/models/table';
import { HelperService } from 'src/app/services/helper.service';

@Component({
    selector: 'mwp-card-resource',
    templateUrl: './card-resource.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CardResourceComponent implements OnInit, AfterContentChecked {
    @Input() public header: string;
    @Input() public tableHeader: string;
    @Input() public resources: ResourceLink[];
    @Input() public displayCategroyColumn: boolean = true;
    @Input() public displayCarrierColumn: boolean = true;
    @Input() public displayCloseButton: boolean;
    @Input() public isModal: boolean;

    @Output() public closeResources: EventEmitter<any> = new EventEmitter();

    public currentResources: ResourceLink[];
    public tableData: MatTableDataSource<ResourceLink>;
    public tableColumns: TableColumn[] = new Array<TableColumn>();

    constructor(
        private helperService: HelperService,
    ) {
    }

    ngOnInit(): void {
        if (this.tableHeader) {
            this.tableColumns.push({
                columnName: this.tableHeader,
                propertyId: 'linkUrl',
                columnType: TableColumnType.hyperLink,
                dataTypePropertyId: 'linkText',
                isNewTab: true,
            });
        } else {
            this.tableColumns.push({
                columnName: 'Resource',
                propertyId: 'linkUrl',
                columnType: TableColumnType.hyperLink,
                dataTypePropertyId: 'linkText',
                isNewTab: true,
            });
        }

        if (this.displayCategroyColumn)
            this.tableColumns.unshift({
                columnName: 'Category',
                propertyId: 'category',
                columnType: TableColumnType.label,
            });

        if (this.displayCarrierColumn)
            this.tableColumns.push({
                columnName: 'Carrier',
                propertyId: 'carrier',
                columnType: TableColumnType.label,
            });

        this.loadGid();
    }

    ngAfterContentChecked(): void {
        if (this.resources != this.currentResources) {
            this.loadGid();
        }
    }

    private loadGid() {
        if (this.resources)
            this.currentResources = this.helperService.generateResourceIcons(this.resources);
        else
            this.currentResources = this.resources;

        this.tableData = new MatTableDataSource<ResourceLink>();
        this.tableData.data = this.currentResources;
    }

    public openTab(url: string): void {
        window.open(url, "_blank");
    }

    close(): void {
        this.closeResources.emit();
    }
}